<template>
<v-card color="grey lighten-4" min-width="350px" flat >
    <v-toolbar color="primary" dark class="elevation-1" height="50px">
        <v-toolbar-title >Association des calques</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon color="" @click="switchModal('modalLayer', 0)"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-card-text class="mt-1 pa-1">
        <div v-if="!dialogLayer" style="max-height:400px; overflow-y: auto;">
            <v-data-table :headers="headers" :items="items" :items-per-page="10" class="mt-2 elevation-1" >
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>
                            <v-alert class="mb-0" border="left" dense colored-border type="info">Versions</v-alert>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    <v-btn outlined rounded small color="green" @click="dialogLayer = true; lra_source_id=''">
                        Nouveau<v-icon>mdi-playlist-edit</v-icon>
                    </v-btn>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.lra_custom_icon`]="{ item }">
                <v-btn text icon color="" @click="iconDialog[item.lra_id] = !iconDialog[item.lra_id]" >
                    <v-icon >mdi-pencil-plus</v-icon>
                    <v-dialog light v-model="iconDialog[item.lra_id]" hide-overlay width="500">
                        <div style="background-color:white; z-index: 2555;">
                            <v-textarea class="pa-5" label="Icone" counter maxlength="65000" v-model="item.lra_custom_icon"></v-textarea>
                        </div>
                    </v-dialog>
                </v-btn>
                </template>
                <template v-slot:[`item.lra_typ_id`]="{ item }">
                    <v-autocomplete item-text="typ_name" item-value="typ_id"
                        v-model="item.lra_typ_id" :items="getCacheLayerCategory()"
                        clearable label="Catégorie" ></v-autocomplete>
                </template>
                <template v-slot:[`item.lra_tem_id`]="{ item }">
                    <v-autocomplete item-text="tem_label" item-value="tem_id"
                        v-model="item.lra_tem_id" :items="getCacheTheme()" ></v-autocomplete>
                </template>
                <template v-slot:[`item.lra_obt_id`]="{ item }">
                    <v-autocomplete item-text="obt_label" item-value="obt_id"
                        v-model="item.lra_obt_id" :items="objectList[ 'tem' + item.lra_tem_id ]" ></v-autocomplete>
                </template>
                <template v-slot:[`item.lra_ctp_id_default`]="{ item }">
                    <v-autocomplete item-text="ctp_label" item-value="ctp_id"
                        v-model="item.lra_ctp_id_default" :items="fieldList[ 'obt' + item.lra_obt_id ]"
                        clearable label="Champ par défaut" ></v-autocomplete>
                </template>
                <template v-slot:[`item.lra_allow_team_leader`]="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                v-bind="attrs" v-on="on"
                                :color="item.lra_allow_team_leader ? 'green' : 'grey lighten-2'"
                                @click="toggleTeamLeader(item)"
                            >mdi-account-tie</v-icon>
                        </template>
                        <span>{{ item.lra_allow_team_leader ? 'Affectation chef d\'équipe activée' : 'Cliquer pour activer l\'affectation d\'un chef d\'équipe' }}</span>
                    </v-tooltip>
                </template>
                <template v-slot:[`item.lra_sta_id`]="{ item }">
                    <v-icon  left color="green" @click="saveLayerAssoc(item)"> <!-- v-show="item.pre_lra_obt_id !== item.lra_obt_id" -->
                        mdi-content-save
                    </v-icon>
                </template>
                <template v-if="!loading.getLayer" slot="no-data">
                    <v-alert :value="true" color="error" icon="mdi-alert"> Aucune donnée </v-alert>
                </template>
                <template v-if="loading.getLayer" slot="no-data">
                    <v-progress-linear :indeterminate="true"></v-progress-linear>
                </template>
            </v-data-table> 
        </div>
<!--    <div v-if="!dialogLayer" class="text-lg-right" style="background-color:#fff;">
    <v-divider></v-divider>
        <v-btn color="success" @click.native="saveLayerAssoc()">Enregistrer</v-btn>
        <v-btn color="blue darken-1" text @click.native="switchModal('modalLayer', 0)">Annuler</v-btn>
    </div>
-->
    <!-- Creation de Layer -->
        <v-layout v-if="dialogLayer" row justify-center class="pa-5" style="background-color:white;">
            <v-card>       
            <v-card-text>
                <v-text-field v-model="lra_source_id" label="Ajouter un calque" required></v-text-field>
            </v-card-text>
            <v-card-actions class="text-lg-right">
                <v-btn color="success" :loading="saveProgress" @click.native="postLayerAssoc()" :disabled="saveProgress">Enregistrer</v-btn>
                <v-btn color="primmary" @click.native="dialogLayer = false;">Retour </v-btn>
            </v-card-actions>            
            </v-card>
        </v-layout>
    </v-card-text>
</v-card>
</template>

<script>
import { useTypeStore } from '@/stores/type'
import { useStateStore } from '@/stores/state'
import { useThemeStore } from '@/stores/theme'
import { useObjectTypeStore } from '@/stores/objectType'
import { layerUpdateService } from '@/rxjsServices';

export default {
    name: 'tab-layer',
    props: ['objProject', 'prv_id', 'switchModal'],
    data: function () {
      return {
            saveProgress: false,         // Enregistrement en cours...
            loading: { getLayer: false },
            dialogLayer: false, lra_source_id: '',
            headers: [
                { text: 'Source', align: 'left', value: 'lra_source_id'},
                { text: 'Catégorie', align: 'left', value: 'lra_typ_id'},
                { text: 'Icone',  align: 'left', value: 'lra_custom_icon'},
                { text: 'Theme',  align: 'left', value: 'lra_tem_id'},
                { text: 'objet',  align: 'left', value: 'lra_obt_id'},
                { text: 'Champ defaut', align: 'left', value: 'lra_ctp_id_default'},
                { text: 'Chef d\'équipe', value: 'lra_allow_team_leader' },
                { text: 'Statut', value: 'lra_sta_id' }
            ],
            items: [],
            themeList : this.getCacheObjectType(),
            objectList : {},
            fieldList  : {},
            iconDialog: {}
      }
    },
    beforeMount: function(){
        let objectType = this.getCacheObjectType()
        objectType.forEach(obt => {
            if( this.objectList[ 'tem' + obt.obt_tem_id ] === undefined ){
                this.objectList[ 'tem' + obt.obt_tem_id ] = []
            }
            this.objectList[ 'tem' + obt.obt_tem_id ].push(obt)
        });
        this.objectList[ 'temnull' ]  = []
        this.objectList[ 'tem0' ]     = []
        this.fetchCardTemplates()
    },
    mounted: function (){
        this.getLayerAssoc()
    },
    methods: {
        getLayerAssoc(){
            this.loading.getLayer = true
            this.$http.get( '/layersassoc/?per_page=false&lra_prv_id=' + this.prv_id )
            .then( (response) => {
                if( Object.prototype.toString.call( response.data.data ) === '[object Array]' ) {
                    response.data.data.forEach(item => {
                        item.pre_lra_tem_id = item.lra_tem_id
                        item.pre_lra_obt_id = item.lra_obt_id
                    })
                    response.data.data.forEach( (item) => {
                        this.$set(this.iconDialog, item.lra_id, false)
                    })

                    this.items = response.data.data
                }
                this.loading.getLayer = false
            })
        },
        saveLayerAssoc(item){
            const payload = {
                lra_prv_id: item.lra_prv_id,
                lra_sta_id: item.lra_sta_id,
                lra_sta_id_type: item.lra_sta_id_type,
                lra_source_id: item.lra_source_id,
                lra_typ_id: item.lra_typ_id,
                lra_tem_id: item.lra_tem_id,
                lra_obt_id: item.lra_obt_id,
                lra_ctp_id_default: item.lra_ctp_id_default,
                lra_default_visibility: item.lra_default_visibility,
                lra_color: item.lra_color,
                lra_custom_icon: item.lra_custom_icon,
                lra_allow_team_leader: item.lra_allow_team_leader ? 1 : 0,
                lra_computed_fields: item.lra_computed_fields,
            }
            this.$http.put( '/layersassoc/' + item.lra_id, payload )
            .then( (response) => {
                this.items.forEach( elem => {
                    if( response.data.data && elem.lra_id == response.data.data.lra_id ){
                        elem.pre_lra_tem_id = response.data.data.lra_tem_id
                        elem.pre_lra_obt_id = response.data.data.lra_obt_id
                    }
                })
                this.$root.$toast({ color: 'success', text: 'Association enregistrée !' })
                layerUpdateService.sendLayer(this.items)
            }).catch((error) => {
                console.error(error.response?.data)
                this.$root.$toast({ color: 'error', text: JSON.stringify(error.response?.data?.errors || error.message) })
            })
        },
        toggleTeamLeader(item){
            item.lra_allow_team_leader = item.lra_allow_team_leader ? 0 : 1
            this.saveLayerAssoc(item)
        },
        postLayerAssoc(){
            this.$http.post( '/layersassoc/', { 
                lra_source_id: this.lra_source_id, lra_sta_id: 'GEN01', 
                lra_sta_id_type: 'LAY01', lra_prv_id: this.prv_id,
                lra_default_visibility: 1, lra_color: '#757575', 
            }).then( () => {
                this.dialogLayer = false
                this.lra_source_id = ''
                this.getLayerAssoc()
                this.$root.$toast({ color: 'success', text: 'Association enregistrée !' })
                layerUpdateService.sendLayer(this.items)
            })
        },
        addLayer(){
            this.$http.post( '/geojson/', { _method: 'POST', _path: 'geojson/' + this.objProject.pro_id + '/layeradd', lra_source_id: this.lra_source_id } )
            .then( () => {
                this.dialogLayer = false
                this.$root.$toast({ text: 'Calque enregistré !' })
                this.lra_source_id = ''
                this.getLayerAssoc()
            })
        },
        getCacheType () {
            const typeStore = useTypeStore()
            return typeStore.itemListByGroup
        },
        getCacheState () {
            const stateStore = useStateStore()
            return stateStore.itemListByGroup
        },
        getCacheLayerCategory () {
            const typeStore = useTypeStore()
            return typeStore.itemListByGroup['LCA'] || []
        },
        getCacheTheme () {
            const themeStore = useThemeStore()
            return themeStore.itemList
        },
        getCacheObjectType () {
            const objectTypeStore = useObjectTypeStore()
            return objectTypeStore.itemList
        },
        fetchCardTemplates () {
            this.$http.get( '/cardtemplates/?per_page=9999' ).then( (response) => {
                if( Object.prototype.toString.call( response.data.data ) === '[object Array]' ) {
                    response.data.data.forEach(ctp => {
                        const key = 'obt' + ctp.ctp_obt_id
                        if( this.fieldList[ key ] === undefined ){
                            this.fieldList[ key ] = []
                        }
                        this.fieldList[ key ].push(ctp)
                    })
                    this.fieldList[ 'obtnull' ] = []
                    this.fieldList[ 'obt0' ]    = []
                }
            })
        },
    },
    components: { }
}
</script>